export default {
    ads: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/ad/state.js